import Vue from "vue";

/**
 * Class Profile Service
 */
export default class RankingService extends Vue {
    
    private customActions = {
        show: { method: 'GET', url: 'auth/ranking/{periodicity}{/platform_id}{/squad}' },
    };
    
    private resource: any = this.$resource('auth/ranking/', {}, this.customActions);

    public async show(periodicity: string, platform_id?: number, squad?:boolean) {
       
        return await this.resource.show({ periodicity, platform_id, squad }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }
}